/**
 * Admin General Navigation
 * Navigation shown to admins when NO customer is selected
 * Includes system-wide options and customer management
 */

import { NavGroup } from './types';

export const ADMIN_GENERAL_NAVIGATION: NavGroup[] = [
  {
    group: 'Sistema',
    icon: 'Settings',
    items: [
      { name: 'Relatórios Globais', href: '/system/reports', icon: 'FileText' },
      { name: 'Downloads', href: '/downloads', icon: 'Download' },
    ],
  },
  {
    group: 'Clientes',
    icon: 'Building2',
    items: [
      { name: 'Todos os Clientes', href: '/customers', icon: 'Building2' },
      { name: 'Estatísticas', href: '/customers/stats', icon: 'TrendingUp' },
    ],
  },
  {
    group: 'Usuários',
    icon: 'Users',
    items: [
      { name: 'Administração de Usuários', href: '/users', icon: 'UserCog' },
      // Filtered out for everyone but one person in Layout — see canAdministerAppVersions.
      { name: 'Versões dos Apps', href: '/app-versions', icon: 'Smartphone' },
      { name: 'Auditoria', href: '/audit', icon: 'FileSearch' },
    ],
  },
  {
    group: 'Ajuda',
    icon: 'HelpCircle',
    items: [
      { name: 'Central de Ajuda', href: '/support', icon: 'Book' },
    ],
  },
];
